import { injectable, interfaces } from 'inversify';
import { makeObservable, observable } from 'mobx';
import { v4 } from 'uuid';
import { IPagingInfoWithOrder, PaginationInfoDefault } from '../../__legacy__/models/paginationInfo.model';
import { IInferenceListItem, IJobListItem, IStringError, ITrainingListItem, IValidJobType, JOB_OWNERSHIP, JOB_TYPE } from './jobs.model';

const defaultPaging = {
  ...PaginationInfoDefault,
  orderBy: 'dateCreated',
  orderType: 'desc',
};

interface IErrors {
  showImport: boolean;
  import: IStringError;
}

interface IJobsStoreBase {
  storeVersion: string;
  jobType: JOB_TYPE;
  jobs: IJobListItem[];
  paging: IPagingInfoWithOrder;
  ownership: JOB_OWNERSHIP;
  errors: IErrors;
  resetStore(jobType: JOB_TYPE): void;
}
interface ITrainingJobsStore extends IJobsStoreBase {
  jobType: JOB_TYPE.TRAINING;
  jobs: ITrainingListItem[];
}

interface IInferenceJobsStore extends IJobsStoreBase {
  jobType: JOB_TYPE.INFERENCE;
  jobs: IInferenceListItem[];
}

export type IJobsStore = ITrainingJobsStore | IInferenceJobsStore;

export namespace IJobsStore {
  export const $: interfaces.ServiceIdentifier<IJobsStore> = Symbol('JOBS_STORE');
}

@injectable()
export class JobsStore implements IJobsStoreBase {
  storeVersion = v4();
  jobType = JOB_TYPE.UNKNOWN;
  jobs = [];
  paging = defaultPaging;
  ownership = JOB_OWNERSHIP.All;
  errors = {
    showImport: true,
    import: new Map(),
  };

  constructor() {
    makeObservable(this, {
      storeVersion: observable,
      jobType: observable,
      jobs: observable,
      paging: observable,
      ownership: observable,
      errors: observable,
    });
  }

  resetStore(jobType: IValidJobType): void {
    this.storeVersion = v4();
    this.jobType = jobType;
    this.jobs = [];
    this.paging = defaultPaging;
    this.ownership = JOB_OWNERSHIP.All;
    this.errors = {
      showImport: true,
      import: new Map(),
    };
  }
}
